import { MobileIcon, Logo} from './HeroElements'
import { Link as LinkS } from 'react-scroll'
import dinoLogo from '../../images/dinologo.png'
import back from '../../images/headanimation.gif'
import './style.css'
import './mouse.scss'
import {FaBars} from 'react-icons/fa'
import insta from '../../images/insta.png'
import twi from '../../images/twitter.png'
import dc from '../../images/dc.png'
import movie from '../../video/splash.mp4'
import { animateScroll as scroll } from 'react-scroll'


const HeroSection = ({toggle}) => {
    

    // function enableBodyScroll() {
    //     if (document.readyState === 'complete') {
    //       document.body.style.position = '';
    //       document.body.style.overflowY = '';
      
    //       if (document.body.style.marginTop) {
    //         const scrollTop = -parseInt(document.body.style.marginTop, 10);
    //         document.body.style.marginTop = '';
    //         window.scrollTo(window.pageXOffset, scrollTop);
    //       }
    //     } else {
    //       window.addEventListener('load', enableBodyScroll);
    //     }
    //   }
      
      // if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        
      //   window.addEventListener("DOMContentLoaded", (e)=>{
                    
      //     const temp = document.querySelector('.temp');
      //     const name = document.querySelector('.name')  
      //     temp.classList.add('show');
      //     name.classList.add('show');})
            
      //   } else {
        
      //     window.addEventListener("DOMContentLoaded", (e)=>{
      //       const splash = document.querySelector('.splash');
      //       disableBodyScroll({savePosition: true});
      //       setTimeout(()=>{
      //           enableBodyScroll()
      //           splash.classList.add('display-none');
      //       }, 6500)
      //       const temp = document.querySelector('.temp');
      //       const name = document.querySelector('.name')  
      //       temp.classList.add('show');
      //       name.classList.add('show');
            
      //   })
        
      //   }
        


      function disableBodyScroll({ savePosition = false } = {}) {
        if (document.readyState === 'complete') {
          if (document.body.scrollHeight > window.innerHeight) {
            if (savePosition) document.body.style.marginTop = `-${window.pageYOffset}px`;
            document.body.style.position = 'fixed';
            document.body.style.overflowY = 'scroll';
          }
        } else {
          window.addEventListener('load', () => disableBodyScroll({ savePosition }));
        }
      }

    window.addEventListener("scroll", ()=>{
        const header = document.querySelector('header');
        header.classList.toggle('sticky', window.scrollY > 0);
    });
    
    
    

    const toggleHome = () => {
        scroll.scrollToTop();
    }

    const skip = () => {
      const splash = document.querySelector('.splash')
      const temp = document.querySelector('.temp');
      const name = document.querySelector('.name')
      // enableBodyScroll();
      splash.classList.add('display-none')
      temp.classList.add('show');
      name.classList.add('show');
    }

    return (
        
<>

<div className="splash">

{/* <button className="skip" onClick={skip}>SKIP</button> */}
{/* <video autoPlay muted className="fade-in"> */}

{/* <source src={movie} type="video/mp4" /> */}
{/* </video> */}



</div>

        <header>

        <img src= {back} alt="background" className = "banner"/>
        
        <p className="temp">WELCOME <br/>TO</p>
        
        <p className="name">THE DINOMENSION</p>
        
        <p className="mouse"></p>

        <nav>
            <img className="navLogo" src={dinoLogo} alt="navLogo" onClick={toggleHome}></img>
            <ul>
                
                <li></li>
                <li><LinkS to ="Comics" offset={-100} smooth={true} duration={1000} style={{background:"white", borderRadius:"10px", padding:"10px 30px", cursor:"pointer", color:"black"}}>THE COMIC</LinkS></li>
                <li><LinkS to ="Intro" smooth={true} duration={1000} offset={-90} style={{cursor:"pointer"}} >INTRO</LinkS></li>
                <li><LinkS to ="Roadmap" offset={-90} smooth={true} duration={1000} style={{cursor:"pointer"}}>ROADMAP</LinkS></li>
                <li><LinkS className="mint" to ="Mint" offset={-100} smooth={true} duration={1000} style={{cursor:"pointer"}}>MINT</LinkS></li>
                <li><LinkS to ="FAQs" smooth={true} duration={1000} offset={-90} style={{cursor:"pointer"}}>FAQS</LinkS></li>
                <li><LinkS to ="Team" smooth={true} duration={1000} offset={-90}  style={{cursor:"pointer"}}>TEAM</LinkS></li>
                <li><LinkS to ="Contact" smooth={true} duration={1000} style={{cursor:"pointer"}}>COMMUNITY</LinkS></li>
                <MobileIcon onClick = {toggle} >
                 <FaBars />
                </MobileIcon>
            </ul>
        </nav>
        <div className="bottom">
            
            <a target="_blank" href="https://www.instagram.com/the_dnms_nft/"><img src={insta} className="contact" alt="insta"/></a>
            <a target="_blank" href="https://twitter.com/The_DNMS_NFT"><img src={twi} className="contact1" alt="twitter"/></a>
            <a target="_blank" href="https://discord.gg/wQaH48BfdK"><img src={dc} className="contact2" alt="dc"/></a>

        </div>
        
        </header>
        </>        
    )
}

export default HeroSection
